/* ===== "Complete the Look" / "Shop the set" pairing module =====
   Anchor ("This piece") + "+" chained companion cards. Both the anchor AND every companion with
   more than one real variant get their own inline chip picker:
     - Companions start unresolved (step 0) same as before.
     - The anchor pre-fills from whatever is currently selected in the main PDP form (so it's
       never blank), and stays synced to that main selector -- UNTIL the shopper picks something
       directly in this widget, at which point their in-widget choice takes over as authoritative
       for that card's own "Add to bag" action.
     - Once a card resolves, its chips collapse to a small "Change" control instead of
       disappearing for good, so a shopper can reopen and repick either item.

   Individual add-to-bag: every card (anchor + each companion) has its own standalone
   [data-item-single-add] button -- clicking it adds ONLY that one card's currently-resolved
   variant via the same window.YG.addToCart used everywhere else on the PDP, so cart
   badges/drawer/subtotal stay in sync through the site's one real cart-refresh path. The button
   stays disabled until that card has a resolved variant (single-variant cards resolve
   immediately on render; multi-variant cards resolve once the shopper picks through the chip
   UI), so it never fires an add with no variant chosen. Each card's image and title are also
   real links to that product's own page (see pc-link / .n in sections/pdp-pairs-with.liquid), so
   a shopper can leave the widget entirely and view the item on its own PDP. */
(function(){
  function moneyFmt(cents){
    cents = parseInt(cents, 10) || 0;
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function isColorName(n){
    return (window.YG && typeof window.YG.isColorOptionName === 'function') ? window.YG.isColorOptionName(n) : /^colou?r$/i.test(n || '');
  }
  function swatch(n){
    return (window.YG && typeof window.YG.swatchColor === 'function') ? window.YG.swatchColor(n) : '#ccc';
  }

  function syncSingleAddButtons(anchor, items){
    var anchorBtn = anchor && anchor.querySelector('[data-item-single-add]');
    if(anchorBtn) anchorBtn.disabled = !anchor.getAttribute('data-variant');
    items.forEach(function(card){
      var btn = card.querySelector('[data-item-single-add]');
      if(btn) btn.disabled = !card.getAttribute('data-variant');
    });
  }

  function syncButtons(section){
    if(!section) return;
    var anchor = section.querySelector('[data-anchor]');
    var items = [].slice.call(section.querySelectorAll('[data-item]'));
    syncSingleAddButtons(anchor, items);
  }

  function wirePicker(card, section){
    if(card._pv) return card._pv;
    var dataEl = card.querySelector('[data-pvar]');
    var ui = card.querySelector('[data-pvar-ui]');
    if(!dataEl || !ui) return null;
    var data;
    try{ data = JSON.parse(dataEl.textContent); }catch(e){ return null; }

    var steps = [];
    data.opts.forEach(function(name, i){
      var vals = {};
      data.v.forEach(function(v){ vals[v.o[i]] = true; });
      if(Object.keys(vals).length > 1) steps.push(i);
    });
    var chosen = new Array(data.opts.length).fill(null);
    data.opts.forEach(function(name, i){
      if(steps.indexOf(i) < 0) chosen[i] = data.v.length ? data.v[0].o[i] : null;
    });
    var ptr = steps.length; // start "resolved" if we can pre-fill from an existing data-variant
    var touched = false;

    function seedFromVariant(variantId){
      if(!variantId) return false;
      var match = data.v.find(function(v){ return String(v.id) === String(variantId); });
      if(!match) return false;
      chosen = match.o.slice();
      ptr = steps.length;
      return true;
    }

    var initialVariant = card.getAttribute('data-variant');
    if(!seedFromVariant(initialVariant)){ ptr = 0; }

    function resolve(){
      return data.v.find(function(v){
        return v.a && data.opts.every(function(_, k){ return chosen[k] == null || v.o[k] === chosen[k]; });
      });
    }

    function render(){
      var gi = steps[ptr];
      if(gi === undefined){
        var match = resolve();
        if(match){
          card.setAttribute('data-variant', match.id);
          card.setAttribute('data-price', match.p);
          var priceEl = card.querySelector('[data-item-price]');
          if(priceEl) priceEl.textContent = moneyFmt(match.p);
          card.classList.add('picked');
        } else {
          card.removeAttribute('data-variant');
        }
        ui.innerHTML = steps.length ? '<button type="button" class="pv change" data-pv-change>Change</button>' : '';
        syncButtons(section);
        return;
      }
      card.removeAttribute('data-variant');
      var seen = [], avail = {};
      data.v.forEach(function(v){
        for(var k = 0; k < data.opts.length; k++){
          if(k === gi) continue;
          if(chosen[k] != null && v.o[k] !== chosen[k]) return;
        }
        var val = v.o[gi];
        if(seen.indexOf(val) < 0) seen.push(val);
        if(v.a) avail[val] = true;
      });
      var isColor = isColorName(data.opts[gi]);
      var back = ptr > 0 ? '<button type="button" class="pv back" data-pv-back>&#8249;</button>' : '';
      ui.innerHTML = back + seen.map(function(val){
        var dis = avail[val] ? '' : ' disabled';
        var on = chosen[gi] === val ? ' on' : '';
        var safeVal = String(val).replace(/"/g, '&quot;');
        if(isColor){
          return '<button type="button" class="pv dot' + on + '"' + dis + ' style="background:' + swatch(val) + '" data-pv-val="' + safeVal + '" title="' + safeVal + '" aria-label="' + safeVal + '"></button>';
        }
        return '<button type="button" class="pv' + on + '"' + dis + ' data-pv-val="' + safeVal + '">' + safeVal + '</button>';
      }).join('');
      syncButtons(section);
    }

    ui.addEventListener('click', function(e){
      var change = e.target.closest('[data-pv-change]');
      if(change){ touched = true; ptr = 0; render(); return; }
      var back = e.target.closest('[data-pv-back]');
      if(back){ ptr = Math.max(0, ptr - 1); render(); return; }
      var chip = e.target.closest('[data-pv-val]');
      if(chip && !chip.disabled){
        touched = true;
        chosen[steps[ptr]] = chip.getAttribute('data-pv-val');
        ptr++;
        render();
      }
    });

    render();

    var api = {
      isTouched: function(){ return touched; },
      syncFromVariant: function(variantId){
        if(touched) return;
        if(seedFromVariant(variantId)) render();
      }
    };
    card._pv = api;
    return api;
  }

  function wireCards(section){
    var anchor = section.querySelector('[data-anchor].needs-pick');
    if(anchor) wirePicker(anchor, section);
    section.querySelectorAll('[data-item].needs-pick').forEach(function(card){ wirePicker(card, section); });
    syncButtons(section);

    if(anchor && anchor._pv){
      var mainButtons = [].slice.call(document.querySelectorAll('.pdp-addrow [data-add]'));
      if(mainButtons.length){
        var mo = new MutationObserver(function(){
          mainButtons.forEach(function(btn){ anchor._pv.syncFromVariant(btn.getAttribute('data-variant')); });
        });
        mainButtons.forEach(function(btn){ mo.observe(btn, { attributes: true, attributeFilter: ['data-variant'] }); });
      }
    }
  }

  function refreshCartUi(){
    var cartUrl = (window.YG && window.YG.routes && window.YG.routes.cart) || '/cart';
    fetch(cartUrl + '.js').then(function(r){ return r.json(); }).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(c){ c.textContent = '(' + cart.item_count + ')'; });
      document.querySelectorAll('[data-cart-badge]').forEach(function(bd){
        bd.textContent = cart.item_count;
        if(cart.item_count > 0){ bd.setAttribute('data-on', ''); }
      });
    }).catch(function(){});
  }

  function addSingle(card, btn){
    var variantId = card.getAttribute('data-variant');
    if(!variantId){
      card.classList.add('miss');
      setTimeout(function(){ card.classList.remove('miss'); }, 500);
      return;
    }
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    var result = window.YG && window.YG.addToCart ? window.YG.addToCart(parseInt(variantId, 10), 1) : Promise.resolve(false);
    Promise.resolve(result).then(function(ok){
      if(ok){
        btn.textContent = 'Added ✓';
        refreshCartUi();
        if(window.YG && typeof window.YG.openCart === 'function') window.YG.openCart();
      } else {
        btn.textContent = orig;
      }
      setTimeout(function(){ btn.disabled = false; btn.textContent = orig; }, 1600);
    }).catch(function(){
      btn.disabled = false; btn.textContent = orig;
    });
  }

  document.addEventListener('click', function(e){
    var singleBtn = e.target.closest('[data-item-single-add]');
    if(singleBtn){
      e.preventDefault();
      var card = singleBtn.closest('[data-anchor], [data-item]');
      if(card) addSingle(card, singleBtn);
    }
  });

  function initSection(section){
    if(section._pairReady) return;
    section._pairReady = true;
    wireCards(section);
  }

  function initAll(root){
    (root || document).querySelectorAll('section.pairing').forEach(initSection);
  }
  initAll();
  document.addEventListener('yg:contentswap', function(e){ initAll((e.detail && e.detail.root) || document); });
})();
